/**
 * Helper class for strings
 */
export class StringHelper {
  /**
   * Checks if the string is null or empty / only blanks
   * @param str The strig to check
   * @returns true if the string is null or empty / only blanks
   */
  public static isNullOrEmpty(str: string): boolean {
    return !str?.trim();
  }
}
